import { curry } from 'ramda';
import { IAppState } from '../../redux';

export const selectIsJKSelected = curry((isHouseRequired: boolean, state: IAppState): boolean => {
  const { jk } = state.offer.geo || {};

  if (!jk) {
    return false;
  }

  return !!jk.id &&
    (!isHouseRequired || !!jk.house?.id);
});
